import { FC } from 'react';

interface FastBackwardIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const FastBackwardIcon: FC<FastBackwardIconProps> = ({ width = 16, height = 16, color = 'white' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g id="fast-backward">
        <g id="Icon">
          <path
            d="M14.6665 10.958C14.6665 11.7113 14.6665 12.088 14.5143 12.2727C14.3821 12.4331 14.1826 12.5227 13.9749 12.5149C13.7357 12.506 13.4542 12.2557 12.8911 11.7552L9.56335 8.79717C9.25315 8.52145 9.09806 8.38358 9.0409 8.22079C8.99071 8.07783 8.99071 7.92204 9.0409 7.77908C9.09806 7.61629 9.25315 7.47843 9.56335 7.2027L12.8911 4.24467C13.4542 3.74416 13.7357 3.49391 13.9749 3.48496C14.1826 3.47719 14.3821 3.56677 14.5143 3.7272C14.6665 3.91187 14.6665 4.28855 14.6665 5.0419V10.958Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.33312 10.958C7.33312 11.7113 7.33312 12.088 7.18095 12.2727C7.04874 12.4331 6.84926 12.5227 6.64152 12.5149C6.4024 12.506 6.12086 12.2557 5.5578 11.7552L2.23001 8.79717C1.91982 8.52145 1.76472 8.38358 1.70757 8.22079C1.65737 8.07783 1.65737 7.92204 1.70757 7.77908C1.76472 7.61629 1.91982 7.47843 2.23001 7.2027L5.5578 4.24467C6.12086 3.74416 6.4024 3.49391 6.64152 3.48496C6.84926 3.47719 7.04874 3.56677 7.18095 3.7272C7.33312 3.91187 7.33312 4.28855 7.33312 5.0419V10.958Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default FastBackwardIcon;
